import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';
import { ObjectNode } from 'src/app/services/object-list.service';

@Injectable({
  providedIn: 'root'
})
export class GetTaskListService extends AbstractRestService{

  postInit(): void { }

  
  taskList(site: string, object: string):Observable<GenericLambdaReturn<TaskListType>> 
  {
    let params:any={};

    params.Site = site.toString();
    params.Object = object.toString();
        
    return this.get({
      ApiResource: "/configgettask",
      data: params
    }); 
  }

  objectList(): Observable<GenericLambdaReturn<ObjectNode[]>> {
    return this.get({
      ApiResource: "/config/objects",
      repeatCall: true   
    });
  }

  deleteObject(displayName: string, object: string):Observable<GenericLambdaReturn<any>> {
    let params:any={};

    params.DisplayName = displayName.toString();
    params.Object = object.toString();

    return this.delete({
      ApiResource: "/configobjectdelete",
      data: params      
    });
  }

  editObject(display_name: string, lineID: number, subLineID: number, object: string, section: string, subsection: string, description: string, eamasset: string, loadtime: number, manualLoad: number, requirecomment: number, requireworkrequest: number, defaulteamasset:number):Observable<GenericLambdaReturn<any>> {
    let params:any={};
    params.DisplayName = display_name;
    params.Object = object;
    params.LineID = lineID ? lineID : -1;
    params.SubLineID = subLineID ? subLineID : -1;
    params.Section = section;
    params.SubSection = subsection;
    params.ManualDescription = description;
    params.EAMAsset = eamasset ? eamasset : ''
    eamasset ? params.EAMAsset = eamasset : null
    params.LoadTime = loadtime;
    params.ManualLoad = manualLoad;
    params.RequireComment = requirecomment;
    params.RequireWorkRequest = requireworkrequest;
    params.DefaultEAMAsset = defaulteamasset;
 
    return this.get({
      ApiResource: "/configobject",
      data: params,
      repeatCall: false
    });
  } 
  
  manualLoad(site: string, environment: string, objectID: string):Observable<GenericLambdaReturn<any>> {
    let params:any={};
    params.Site = site;
    params.PfcyEnvironment = environment;
    params.ObjectID = objectID;

    return this.post({
      ApiResource: "/manualload",
      data: params,
      repeatCall: false
    });
  }

}



export type TaskListType = {
  tasks: Task[];
}

export type Task = {
 id?:number;
 type:string;
 label:string;
 task_type:string;
 task:string;
 time:string;
 otherinfo:string;
 form_number:string;
 revision:string;
}